import React, { FC, useState } from "react";
import { Alert, Button } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";
import { Props, defaultData, WeatherLocation } from "./types";
import CitySearchSelect from "./CitySearchSelect";
import { resolveCurrentLocation } from "./location";

const WeatherSettings: FC<Props> = ({ data = defaultData, setData }) => {
  const [locating, setLocating] = useState(false);
  const hasLegacyCity = typeof data.city === "string" && data.city.length > 0;

  const handleLocationChange = (location?: WeatherLocation) => {
    setData({
      location,
      units: data.units ?? "metric",
      style: data.style ?? "cinematic",
      autoLocateAttempted: true,
    });
  };

  const handleUseCurrentLocation = async () => {
    setLocating(true);
    try {
      const location = await resolveCurrentLocation();
      setData({
        location,
        units: data.units ?? "metric",
        style: data.style ?? "cinematic",
        autoLocateAttempted: true,
      });
    } finally {
      setLocating(false);
    }
  };

  return (
    <div>
      {hasLegacyCity ? (
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 12 }}
          message="Please re-select your weather location"
          description="The weather provider has been upgraded, so older saved cities need to be selected again."
        />
      ) : null}
      <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 12 }}>
        <Button
          icon={<EnvironmentOutlined />}
          loading={locating}
          onClick={handleUseCurrentLocation}
        >
          Use current location
        </Button>
      </div>
      <label>
        City
        <CitySearchSelect value={data.location} onChange={handleLocationChange} />
      </label>
    </div>
  );
};

export default WeatherSettings;
